import React from 'react';
import ProjectsGraphQlController from '../../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import _, { forEach } from 'lodash';
import LoadingBar from '../../../components/global/loadingBar';
//import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { ReactComponent as MinusIcon } from '../../../../assets/svg/Project/minus-circle.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import { withRouter } from '../../../../services/withRoute';
import 'react-datepicker/dist/react-datepicker.css';
import InputHeader from '../../global/inputwithHeader';
import CustomDateInput from '../../global/customDateInput';
//import CreatableSelect from 'react-select/creatable';
import Modal from '../../../components/modals';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import jwt_decode from 'jwt-decode';

import moment from 'moment';
import CrewSuggestions from '../../shoots/CrewSuggestions';
import constants from '../../../../utils/constants';

const getShoot = gql`
	query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			id
			tenantId
			projectId
			name
			category
			additionalServices {
				_id
				type
				priceInRupees
			}
			crew {
				count
				role
				subRole
				userIds
				managerIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			childEvents {
				_id
				parentEvent_id
				name
			}
			parentEvent_id
			parentEventName
			city
			venue
			outStation
			date
			time
			reportingTime
			durationInHrs
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
			isDelete
			createdBy
			createdAt
			updatedBy
			updatedAt
		}
	}
`;

const getTenantUsers = gql`
	query TenantUsersList($workspaceIds: [String!]!, $userIds: [ID!]) {
		tenantUsersList(workspaceIds: $workspaceIds, userIds: $userIds) {
			id
			firstName
			lastName
			displayName
			phoneNumber
		}
	}
`;

const getProjectList = gql`
	query VendorsProjects($workspaceId: String!) {
		vendorsProjects(workspaceId: $workspaceId) {
			id
			title
		}
	}
`;

const addAdditionalServices = gql`
	mutation AddAdditionalServices(
		$workspaceId: String!
		$projectId: ID!
		$id: ID!
		$type: AdditionalServicesType!
		$priceInRupees: Int!
	) {
		addAdditionalServices(
			workspaceId: $workspaceId
			projectId: $projectId
			id: $id
			type: $type
			priceInRupees: $priceInRupees
		) {
			message
		}
	}
`;

const deleteAdditionalServices = gql`
	mutation DeleteAdditionalServices(
		$workspaceId: String!
		$projectId: ID!
		$deleteAdditionalServicesId: ID!
		$additionalServicesId: ID!
	) {
		deleteAdditionalServices(
			workspaceId: $workspaceId
			projectId: $projectId
			id: $deleteAdditionalServicesId
			additionalServicesId: $additionalServicesId
		) {
			message
		}
	}
`;

const updateShoot = gql`
	mutation UpdateEvent(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$eventInput: EventInput!
	) {
		updateEvent(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			eventInput: $eventInput
		) {
			id
			tenantId
			projectId
			name
			projectSlNo
			slNo
			category
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			outStation
			city
			venue
			date
			time
			flagLabel
			reportingTime
			durationInHrs
			dateOverlap
			dateTimeOverlap
			parentEvent_id
			projectTitle
			parentEventName
			childEvents {
				_id
				expenses {
					_id
					amount
					billTo
					billDate
					currency
				}
				name
				parentEvent_id
			}
			memoryCards {
				status
				isReceived
			}
			equipments {
				isReceived
				status
			}
			additionalServices {
				type
				_id
			}
			feedBack {
				_id
				submittedBy
				submittedOn
				files {
					_id
					fileType
					originalFileName
					s3KeyOriginal
					originalFileSizeInMb
				}
			}
			unregisteredEqs {
				_id
				status
				manufacturerId
				isReceived
				createdBy {
					id
					name
				}
				createdAt
				receivedAt
				receivedBy {
					id
					name
				}
				description
				quantity
				receivedQuantity
				id
			}
			collaborators {
				designations
				isManager
				tenantUserId
			}
		}
	}
`;
const addShoot = gql`
	mutation AddEvent($workspaceId: String!, $projectId: ID!, $eventInput: EventInput) {
		addEvent(workspaceId: $workspaceId, projectId: $projectId, eventInput: $eventInput) {
			id
		}
	}
`;

const deleteShoot = gql`
	mutation RootMutation($deleteEventId: ID!, $projectId: ID!) {
		deleteEvent(id: $deleteEventId, projectId: $projectId) {
			acknowledged
			deletedId
		}
	}
`;

const updateShootNote = gql`
	mutation UpdateEventNote(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$noteId: ID!
		$noteInput: UpdateNoteInput
	) {
		updateEventNote(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			noteId: $noteId
			noteInput: $noteInput
		) {
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
		}
	}
`;

const addShootNote = gql`
	mutation AddEventNote(
		$workspaceId: String!
		$projectId: ID!
		$eventId: ID!
		$noteInput: NoteInput
	) {
		addEventNote(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			noteInput: $noteInput
		) {
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
		}
	}
`;

const deleteShootNote = gql`
	mutation DeleteEventNote($workspaceId: String!, $projectId: ID!, $eventId: ID!, $noteId: ID!) {
		deleteEventNote(
			workspaceId: $workspaceId
			projectId: $projectId
			eventId: $eventId
			noteId: $noteId
		) {
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
		}
	}
`;
const getEventsList = gql`
	query Data($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			data {
				id
				name
			}
		}
	}
`;
const mergeEvent = gql`
	mutation MergeEvent($projectId: ID!, $mergeEventId: ID!, $targetEventId: ID!) {
		mergeEvent(projectId: $projectId, id: $mergeEventId, targetEvent_id: $targetEventId) {
			message
		}
	}
`;
const unMergeEvent = gql`
	mutation RootMutation($projectId: ID!, $unMergeEventId: ID!) {
		unMergeEvent(projectId: $projectId, id: $unMergeEventId) {
			message
		}
	}
`;
const nameOptions = [
	{ value: 'Bhogesh', label: 'Bhogesh', color: '#FF8B00' },
	{ value: 'Jagadeesh', label: 'Jagadeesh', color: '#FFC400' },
	{ value: 'Abhishek', label: 'Abhishek', color: '#36B37E' },
	{ value: 'Sriram', label: 'Sriram', color: '#00875A' },
	{ value: 'Naveen', label: 'Naveen', color: '#253858' },
];
const categoryOptions = [
	{ value: 'candid', label: 'Candid', color: '#FF8B00' },
	{ value: 'traditional', label: 'Traditional', color: '#FFC400' },
];

class CreateShoot extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.id = 'crew-select_' + Math.random().toFixed(8).slice(2);
		this.state = {
			isShootLoading: true,
			name: null,
			city: null,
			date: null,
			time: '',
			reportingTime: '',
			duration: null,
			venue: null,
			shootcrew: [],
			videocrew: [],
			notes: [],
			activeShootID: props?.activeShootID,
			editShootDetails: {},
			projectNameOptions: [],
			shootDetails: {},
			shootemptyCrewNameArr: {},
			shootemptyCrewCategoryArr: {},
			shootemptyCrewName: null,
			shootemptyCrewCategory: null,
			shootemptyNoteMessage: null,
			videoemptyCrewNameArr: {},
			videoemptyCrewCategoryArr: {},
			videoemptyCrewName: null,
			videoemptyCrewCategory: null,
			videoemptyNoteMessage: null,
			outStation: null,
			emptyShootCrewCategoryError: false,
			emptyVideoCrewCategoryError: false,
			newAddedNote: [],
			editShootNameError: false,
			editShootNameErrorMessage: '',
			editShootDateUnscheduled: false,
			showDropDown: false,
			showDeleteConfirmationModal: false,
			imageSet: false,
			tenantUsersList: {},
			tenantUsersListOptions: [],
			shootcrewNameError: false,
			shootcrewCategoryError: false,
			videocrewNameError: false,
			videocrewCategoryError: false,
			currentTab: 'details',
			storedNote: '',
			projectId: props.projectId,
			projectsNameList: [],
			isProjectsLoading: true,
			limit: 10,
			linkedTo: null,
			page: 1,
			eventNameOptions: [],
			hasNextPage: true,
			timeTypeOptions: [
				{ value: '', label: 'Select Slot' },
				//{ value: 'Early morning', label: 'Early morning' },
				{ value: 'Morning', label: 'Morning' },
				//{ value: 'Afternoon', label: 'Afternoon' },
				{ value: 'Evening', label: 'Evening' },
				//{ value: 'Night', label: 'Night' },
				{ value: 'Full Day', label: 'Full Day' },
			],
			addServOptions: [
				{ value: 'led', label: 'LED Wall' },
				{ value: 'mixingUnit', label: 'Mixing Unit' },
				{ value: 'drone', label: 'Drone' },
				{ value: 'webLive', label: 'Web Live' },
			],
			additionalServices: [],
			showDiscardModal: false,
			disabledBtn: false,
			showAddSvcrDropdown: false,
		};
		this.dropdownref = React.createRef();
		this.addSvcrRef = React.createRef();
		this.addSvcrDropdownRef = React.createRef();
	}

	componentDidMount = async () => {
		let userToken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(userToken);

		const vendorId = this.props.params.vendorID;
		const global = constants.userAccess.global || {};
		const vendor = constants.userAccess.vendors?.[vendorId] || {};
		const crewPlannerUserIds = [...new Set([...(global.crewPlannerUserIds || []), ...(vendor.crewPlannerUserIds || [])])];
		this.setState({ isCrewPlannerUser: crewPlannerUserIds.includes(decoded.user_id) });

		let wJson = {
			workspaceIds: _.has(this.props, 'workspaceID')
				? this.props.workspaceID
				: this.props.params.workspaceID,
		};
		let tenantUserList = [];
		tenantUserList = await this.getWorkspaceTenantUsers(getTenantUsers, wJson);

		if (tenantUserList !== false) {
			let tenantUsersListOptions = [];
			forEach(tenantUserList, (user, key) => {
				let arr = [];
				if (_.has(user, 'firstName'))
					arr.push({
						label: user.firstName + ' ' + user.lastName,
						value: user.id,
					});
				if (_.has(user, 'name'))
					arr.push({
						label: user.name + (user.phoneNumber ? ' - ' + user.phoneNumber : ''),
						value: user.key,
					});

				return tenantUsersListOptions.push(arr[0]);
			});

			if (_.has(this.props, 'isTenantCreate') && this.props.isTenantCreate) {
				const getProjectsVeriables = {
					workspaceId: _.has(this.props, 'workspaceID')
						? this.props.workspaceID
						: this.props.params.workspaceID,
				};
				await this.getProjects(getProjectList, getProjectsVeriables, 'value-label');
			} else {
				this.setState({
					isProjectsLoading: false,
				});
			}

			let jsonEventsList = {
				filters: {
					page: 1,
					limit: 10000,
					projectId: this.props.params.projectID,
					wsTenantIds: [this.props.tenantId],
				},
			};

			if (this.props.activeShootID == null)
				await this.getEventsNameList(getEventsList, jsonEventsList);

			if (this.props.activeShootID !== null) {
				const shootVariables = {
					projectId: this.state.projectId,
					vendorEventId: this.props.activeShootID,
					workspaceId: _.has(this.props, 'workspaceID')
						? this.props.workspaceID
						: this.props.params.workspaceID,
				};
				let response = await this.getShoot(getShoot, shootVariables);
				if (response !== false) {
					let shootDetails = {};
					shootDetails = response;

					let arr = [];
					_.forEach(shootDetails.crewNew, (crew, k) => {
						if (crew.isCustomUser !== true) {
							_.forEach(crew.roles, (roles, j) => {
								let crewArr = [];
								crewArr['name'] = crew.userId;
								crewArr['role'] = roles.role;
								crewArr['subRole'] = roles.subRole;
								crewArr['isManager'] =
									crew.isManager === null ? false : crew.isManager;
								crewArr['isCustomUser'] = crew.isCustomUser;
								arr.push({ ...crewArr });
							});
						}
					});
					shootDetails.crewNew = arr;
					shootDetails.nonEditCrew = [...arr];

					this.setState({
						shootDetails: _.cloneDeep(shootDetails),
						editShootDetails: { ...shootDetails, linkedTo: null },
						tenantUsersListOptions,
						isShootLoading: false,
						userId: decoded.user_id,
					});
				}
			} else {
				this.setState({
					isShootLoading: false,
					tenantUsersListOptions,
					userId: decoded.user_id,
				});
			}

			if (document.getElementById('details')) {
				document.getElementById('details').scrollIntoView();
			}

			document.addEventListener('mousedown', this.handleClickOutside);
		}
	};
	/* 	componentWillMount = async () => {
		if (localStorage.getItem('usertoken')) {
			let usertoken = localStorage.getItem('usertoken');
			var decoded = await jwt_decode(usertoken);

			await this.getTenantUserDetails(decoded.user_id, this.props.match.params.workspaceID);
		}
	}; */
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	handleClickOutside = (event) => {
		if (this.dropdownref.current && !this.dropdownref.current.contains(event.target)) {
			this.setState({
				showDropDown: false,
			});
		}

		if (
			this.addSvcrRef.current &&
			!this.addSvcrRef.current.contains(event.target) &&
			this.addSvcrDropdownRef.current &&
			!this.addSvcrDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showAddSvcrDropdown: false,
			});
		}
	};

	toggleAddSvcrDropDown = (e) => {
		this.setState({
			showAddSvcrDropdown: !this.state.showAddSvcrDropdown,
		});
	};

	handleAddAdditionalService = (service, label) => {
		if (this.props.activeShootID === null) {
			let additionalServices = [...this.state.additionalServices];
			additionalServices.push({ type: service, priceInRupees: 0 });

			this.setState({
				additionalServices,
			});
		} else {
			let json = {
				workspaceId: _.has(this.props, 'workspaceID')
					? this.props.workspaceID
					: this.props.params.workspaceID,
				projectId: _.has(this.props, 'projectId')
					? this.props.projectId
					: this.props.params.projectID,
				id: this.props.activeShootID,
				type: service,
				priceInRupees: 0,
			};

			this.addDeleteShootAdditionalService(addAdditionalServices, json, label, 'add');
		}
	};

	handleDeleteAdditionalService = (service, label, ID) => {
		if (this.props.activeShootID === null) {
			let additionalServices = _.cloneDeep(this.state.additionalServices);
			let index = ID;
			additionalServices.splice(index, 1);
			this.setState({
				additionalServices,
			});
		} else {
			let json = {
				workspaceId: _.has(this.props, 'workspaceID')
					? this.props.workspaceID
					: this.props.params.workspaceID,
				projectId: _.has(this.props, 'projectId')
					? this.props.projectId
					: this.props.params.projectID,
				additionalServicesId: ID,
				deleteAdditionalServicesId: this.props.activeShootID,
			};

			this.addDeleteShootAdditionalService(deleteAdditionalServices, json, label, 'delete');
		}
	};

	fetchMoreOptions = async () => {
		if (
			_.has(this.props, 'isTenantCreate') &&
			this.props.isTenantCreate === true &&
			this.state.hasNextPage === true
		) {
			this.setState({ page: this.state.page + 1 }, async () => {
				const getProjectsVariables = {
					filters: {
						page: this.state.page,
						limit: this.state.limit,
					},
				};
				await this.getProjectNameList(getProjectList, getProjectsVariables);
			});
		}
	};

	toggleDropDown = (e) => {
		this.setState({
			showDropDown: !this.state.showDropDown,
		});
	};

	handleAddShoot = async (e) => {
		let json;

		let projectId = this.state.projectId;
		let workspaceId = this.props.params.workspaceID;
		let updateEventId = this.props.activeShootID;

		let eventInput = {
			name: this.state.name,
			date: this.state.date,
			city: this.state.city,
			outStation: this.state.outStation,

			time: this.state.time === '' || this.state.time === null ? '' : this.state.time,
			venue: this.state.venue,
			notes: this.state.newAddedNote,
			reportingTime:
				this.state.reportingTime === '' || this.state.reportingTime === null
					? ''
					: this.state.reportingTime,
		};

		let crewNew = [];
		let concatenatedCrew = this.state.shootcrew.concat(this.state.videocrew);

		_.forEach(concatenatedCrew, (item, index) => {
			if (item.name === null) {
				crewNew.push({
					userId: null,
					isManager: false,
					roles: [{ role: item.role, subRole: item.subRole }],
				});
				return;
			}
			let foundIndex = -1;
			foundIndex = _.findIndex(crewNew, (crew) => {
				return crew.userId === item.name;
			});
			if (foundIndex !== -1) {
				crewNew[foundIndex].roles.push({ role: item.role, subRole: item.subRole });
				crewNew[foundIndex].isManager =
					crewNew[foundIndex].isManager === true || item.isManager === true
						? true
						: false;
			} else {
				crewNew.push({
					userId: item.name,
					isManager: item.isManager === true ? true : false,
					roles: [{ role: item.role, subRole: item.subRole }],
					userName:
						(_.find(this.state.tenantUsersListOptions, { value: item.name }) || {})
							.label || '',
				});
			}
		});

		/* if (_.size(this.state.additionalServices) > 0) {
			eventInput['additionalServices'] = [...this.state.additionalServices];
		} */

		eventInput['crewNew'] = _.size(crewNew) > 0 ? crewNew : [];
		eventInput.durationInHrs = parseInt(this.state.duration);

		json = {
			projectId,
			updateEventId,
			eventInput,
			workspaceId,
		};

		if (this.state.name == null || this.state.editShootNameError === true) {
			this.setState({
				editShootNameError: true,
			});
		} else if (
			this.state.shootemptyCrewName &&
			(this.state.shootemptyCrewCategory === null || this.state.shootemptyCrewCategory === '')
		) {
			this.setState({
				shootcrewCategoryError: true,
			});
		} else if (
			this.state.videoemptyCrewName &&
			(this.state.videoemptyCrewCategory === null || this.state.videoemptyCrewCategory === '')
		) {
			this.setState({
				videocrewCategoryError: true,
			});
		} else {
			await this.putShoot(addShoot, json, getShoot, null, 'add');
		}
	};

	handleChangeCrewName = (newValue, type = null, role) => {
		this.setState(
			{
				[`${role}emptyCrewNameArr`]: newValue,
				[`${role}emptyCrewName`]: newValue.value,
				[`${role}emptyCrewRole`]: role === 'shoot' ? 'photographer' : 'cinematographer',
			},
			() => {
				if (
					this.state[`${role}emptyCrewCategory`] !== null &&
					this.state[`${role}emptyCrewName`] !== null
				) {
					let arr;
					if (this.props.activeShootID !== null) {
						arr = [...this.state.editShootDetails.crewNew];
						if (
							_.size(
								_.filter(this.state.editShootDetails.crewNew, {
									name: this.state[`${role}emptyCrewName`],
									subRole: this.state[`${role}emptyCrewCategory`],
									role: role === 'shoot' ? 'photographer' : 'cinematographer',
								}),
							) == 0
						) {
							let foundIndex = -1;
							let isManager = false;
							foundIndex = _.findIndex(arr, {
								name: this.state[`${role}emptyCrewName`],
								isManager: true,
							});
							if (foundIndex !== -1) {
								isManager = true;
							}
							arr.push({
								name: this.state[`${role}emptyCrewName`],
								subRole: this.state[`${role}emptyCrewCategory`],
								role: role === 'shoot' ? 'photographer' : 'cinematographer',
								isManager,
							});

							this.setState({
								editShootDetails: {
									...this.state.editShootDetails,
									crewNew: arr,
								},
								[`${role}emptyCrewName`]: null,
								[`${role}emptyCrewCategory`]: null,
								[`${role}emptyCrewCategoryArr`]: {},
								[`${role}emptyCrewNameArr`]: {},
								[`${role}crewNameError`]: false,
								[`${role}crewCategoryError`]: false,
							});
						} else {
							this.setState({
								[`${role}crewNameError`]: true,
								[`${role}crewCategoryError`]: true,
							});
						}
					} else {
						arr = [...this.state[`${role}crew`]];

						if (
							_.size(
								_.filter(this.state[`${role}crew`], {
									name: this.state[`${role}emptyCrewName`],
									subRole: this.state[`${role}emptyCrewCategory`],
									role: this.state[`${role}emptyCrewRole`],
								}),
							) == 0
						) {
							let foundIndex = -1;
							let isManager = false;
							foundIndex = _.findIndex(
								[...this.state.shootcrew, ...this.state.videocrew],
								{
									name: this.state[`${role}emptyCrewName`],
									isManager: true,
								},
							);
							if (foundIndex !== -1) {
								isManager = true;
							}
							arr.push({
								name: this.state[`${role}emptyCrewName`],
								subRole: this.state[`${role}emptyCrewCategory`],
								role: this.state[`${role}emptyCrewRole`],
								isManager: isManager,
							});

							this.setState({
								[`${role}crew`]: arr,
								[`${role}emptyCrewName`]: null,
								[`${role}emptyCrewCategory`]: null,
								[`${role}emptyCrewCategoryArr`]: {},
								[`${role}emptyCrewNameArr`]: {},
								[`${role}crewNameError`]: false,
								[`${role}crewCategoryError`]: false,
							});
						} else {
							this.setState({
								[`${role}crewNameError`]: true,
								[`${role}crewCategoryError`]: true,
							});
						}
					}
				}
			},
		);
	};

	handleSaveShoot = async (e) => {
		let json;
		let projectId = this.state.projectId;
		let updateEventId = this.props.activeShootID;
		let eventInput = _.cloneDeep(this.state.editShootDetails);

		eventInput['durationInHrs'] = parseInt(eventInput['durationInHrs']);

		let crewNew = [];
		_.forEach(this.state.editShootDetails.crewNew, (item, index) => {
			if (item.name === null) {
				crewNew.push({
					userId: null,
					isManager: false,
					roles: [{ role: item.role, subRole: item.subRole }],
				});
				return;
			}
			let foundIndex = -1;
			foundIndex = _.findIndex(crewNew, (crew) => {
				return crew.userId === item.name;
			});
			if (foundIndex !== -1) {
				crewNew[foundIndex].roles.push({ role: item.role, subRole: item.subRole });
				crewNew[foundIndex].isManager =
					crewNew[foundIndex].isManager === true || item.isManager === true
						? true
						: false;
			} else {
				crewNew.push({
					userId: item.name,
					isManager: item.isManager === true ? true : false,
					roles: [{ role: item.role, subRole: item.subRole }],
					userName:
						(_.find(this.state.tenantUsersListOptions, { value: item.name }) || {})
							.label || '',
				});
			}
		});

		eventInput['crewNew'] = _.size(crewNew) > 0 ? crewNew : [];
		json = {
			workspaceId: _.has(this.props, 'workspaceID')
				? this.props.workspaceID
				: this.props.params.workspaceID,
			projectId,
			eventId: updateEventId,
			eventInput: _.pick(
				eventInput,
				_.has(this.props, 'displayOnly') && this.props.displayOnly === 'crew'
					? ['crewNew']
					: [
							'category',
							'city',
							'crewNew',
							'date',
							'durationInHrs',
							'name',
							'time',
							'venue',
							'reportingTime',
							'outStation',
					  ],
			),
		};

		if (this.state.editShootNameError === true || this.state.editShootDetails.name === '') {
		} else if (
			this.state.shootemptyCrewName &&
			(this.state.shootemptyCrewCategory === null || this.state.shootemptyCrewCategory === '')
		) {
			this.setState({
				shootcrewCategoryError: true,
			});
		} else if (
			this.state.videoemptyCrewName &&
			(this.state.videoemptyCrewCategory === null || this.state.videoemptyCrewCategory === '')
		) {
			this.setState({
				videocrewCategoryError: true,
			});
		} else if (
			this.state.editShootNameError === false &&
			this.state.editShootDetails.name !== ''
		) {
			/* if (this.state.editShootDetails.linkedTo !== null) {
				await this.mergeEvent(mergeEvent, {
					projectId: this.state.projectId,
					mergeEventId: this.props.activeShootID,
					targetEventId: this.state.editShootDetails.linkedTo,
				});
			} */
			delete json.eventInput['linkedTo'];
			await this.putShoot(updateShoot, json, getShoot, null);
		}
	};

	handleEventChange = (e, name) => {
		let value;

		if (name === 'date') {
			value = parseInt(moment(e).format('yyyyMMDD'));
		} else if (name === 'reportingTime') {
			value = moment(e).format('hh:mm A');
		} else if (name === 'time-new-format') {
			name = 'time';

			value = e.value;
		} else if (name === 'linkedTo') {
			value = e.value;
		} else if (name === 'outStation') {
			value = !eval(e.target.value);
		} else {
			value = e.target.value;
		}

		if (name === 'duration') {
			if (isNaN(+value)) {
				value = '';
			}
		}

		if (name === 'name') {
			if (value === '') {
				this.setState({
					editShootNameError: true,
					editShootNameErrorMessage: 'Required',
				});
			} else {
				this.setState({
					editShootNameError: false,
					editShootNameErrorMessage: '',
				});
			}
		}

		if (this.props.activeShootID == null) {
			this.setState({
				[name]: value,
			});
		} else {
			if (name === 'duration') {
				name = 'durationInHrs';
			}
			this.setState({
				editShootDetails: {
					...this.state.editShootDetails,
					[name]: value,
				},
			});
		}
	};
	toggleEditCrewManager = (e, id, indx = null, role, subRole, isManager) => {
		e.preventDefault();

		let roles = { shoot: 'photographer', video: 'cinematographer' };
		let arr;
		if (this.props.activeShootID !== null) {
			arr = [...this.state.editShootDetails.crewNew];

			_.forEach(arr, (value, key) => {
				if (value['name'] === id) {
					//delete value['category'];
					value.isManager = isManager;
				}
			});

			this.setState({
				editShootDetails: {
					...this.state.editShootDetails,
					crewNew: arr,
				},
			});
		} else {
			let arrShoot = [...this.state.shootcrew];
			let arrVideo = [...this.state.videocrew];

			_.forEach(arrShoot, (value, key) => {
				if (value['name'] === id) {
					//delete value['subRole'];
					value['isManager'] = isManager;
				}
			});

			_.forEach(arrVideo, (value, key) => {
				if (value['name'] === id) {
					//delete value['subRole'];
					value['isManager'] = isManager;
				}
			});

			this.setState({
				shootcrew: arrShoot,
				videocrew: arrVideo,
			});
		}
	};
	handleEditCrewCategory = (e, id, indx = null, role, subRole) => {
		let roles = { shoot: 'photographer', video: 'cinematographer' };
		let arr;
		if (this.props.activeShootID !== null) {
			arr = [...this.state.editShootDetails.crewNew];
			if (id === null) {
				let tempInx = -1;
				_.forEach(arr, (value, inx) => {
					if (value.role === roles[role]) {
						tempInx++;
						if (tempInx === indx) {
							value.subRole = e.value;
						}
					}
				});

				this.setState({
					editShootDetails: {
						...this.state.editShootDetails,
						crewNew: arr,
					},
				});
			} else if (
				_.size(
					_.filter(this.state.editShootDetails.crewNew, {
						name: id,
						subRole: e.value,
						role: role === 'shoot' ? 'photographer' : 'cinematographer',
					}),
				) == 0
			) {
				_.forEach(arr, (value, key) => {
					if (value['name'] === id && value.role == roles[role]) {
						//delete value['category'];
						value.subRole = e.value;
					}
				});

				this.setState({
					editShootDetails: {
						...this.state.editShootDetails,
						crewNew: arr,
					},
				});
			}
		} else {
			arr = [...this.state[`${role}crew`]];

			if (id === null) {
				let tempInx = -1;
				_.forEach(arr, (value, inx) => {
					if (value.role === roles[role]) {
						tempInx++;
						if (tempInx === indx) {
							value.subRole = e.value;
						}
					}
				});
				this.setState({
					[`${role}crew`]: arr,
				});
			} else if (
				_.size(
					_.filter(arr, {
						name: id,
						subRole: e.value,
						role: roles[role],
					}),
				) == 0
			) {
				_.forEach(arr, (value, key) => {
					if (value['name'] === id) {
						value['subRole'] = e.value;
					}
				});

				this.setState({
					[`${role}crew`]: arr,
				});
			}
		}
	};
	handleEditCrewName = (e, id, indx = null, role, subRole = null) => {
		let arr;
		let crewRole;
		crewRole = role === 'shoot' ? 'photographer' : 'cinematographer';
		if (this.props.activeShootID !== null) {
			arr = [...this.state.editShootDetails.crewNew];
			if (
				id === null &&
				_.size(
					_.filter(arr, {
						name: e.value,
						subRole: subRole,
						role: crewRole,
					}),
				) == 0
			) {
				let tempInx = -1;
				let isManager = false;
				let tempIndex = -1;
				_.forEach(arr, (crw, inx) => {
					if (crw['name'] == e.value && crw['isManager'] === true) {
						isManager = true;
					}
					if (crw.role === crewRole) {
						tempInx++;
						if (tempInx === indx) {
							crw['name'] = e.value;
							tempIndex = inx;
						}
					}
				});

				if (tempIndex !== -1) {
					arr[tempIndex]['isManager'] = isManager;
				}

				this.setState({
					editShootDetails: {
						...this.state.editShootDetails,
						crewNew: arr,
					},
				});
			} else if (
				_.size(
					_.filter(this.state.editShootDetails.crewNew, {
						name: e.value,
						subRole: subRole,
						role: role === 'shoot' ? 'photographer' : 'cinematographer',
					}),
				) == 0
			) {
				let isManager = false;
				let tempIndex = -1;
				_.forEach(arr, (value, key) => {
					if (value['name'] == e.value && value['isManager'] === true) {
						isManager = true;
					}
					if (
						value['name'] == id &&
						value['subRole'] == subRole &&
						crewRole == value['role']
					) {
						value['name'] = e.value;
						tempIndex = key;
					}
				});

				if (tempIndex !== -1) {
					arr[tempIndex]['isManager'] = isManager;
				}

				this.setState({
					editShootDetails: {
						...this.state.editShootDetails,
						crewNew: arr,
					},
				});
			}
		} else {
			arr = [...this.state[`${role}crew`]];

			if (
				id === null &&
				_.size(
					_.filter(arr, {
						name: e.value,
						subRole: subRole,
						role: crewRole,
					}),
				) == 0
			) {
				let tempInx = -1;
				let isManager = false;
				let tempIndex = -1;
				_.forEach([...this.state.shootcrew, ...this.state.videocrew], (crw, inx) => {
					if (crw['name'] == e.value && crw['isManager'] === true) {
						isManager = true;
					}
				});
				tempInx = -1;
				_.forEach(arr, (crw, inx) => {
					if (crw.role === crewRole) {
						tempInx++;
						if (tempInx === indx) {
							crw['name'] = e.value;
							tempIndex = inx;
						}
					}
				});

				if (tempIndex !== -1) {
					arr[tempIndex]['isManager'] = isManager;
				}

				this.setState({
					[`${role}crew`]: arr,
				});
			} else if (
				_.size(
					_.filter(arr, {
						name: e.value,
						subRole: subRole,
						role: crewRole,
					}),
				) == 0
			) {
				let isManager = false;
				let tempIndex = -1;
				_.forEach([...this.state.shootcrew, ...this.state.videocrew], (crw, inx) => {
					if (crw['name'] == e.value && crw['isManager'] === true) {
						isManager = true;
					}
				});
				_.forEach(arr, (value, key) => {
					if (
						value['name'] == id &&
						value['subRole'] == subRole &&
						crewRole == value['role']
					) {
						tempIndex = key;
						arr[key]['name'] = e.value;
					}
				});

				if (tempIndex !== -1) {
					arr[tempIndex]['isManager'] = isManager;
				}

				this.setState({
					[`${role}crew`]: arr,
				});
			}
		}
	};

	handleDeleteCrew = (e, id, category, role, indx) => {
		let arr;
		let tempRole = role === 'shoot' ? 'photographer' : 'cinematographer';
		if (this.props.activeShootID !== null) {
			arr = [...this.state.editShootDetails.crewNew];

			let newArr;
			if (id === null) {
				let tempInx = -1;

				let tempInxValue = null;
				_.forEach(arr, (crw, inx) => {
					if (crw.role === tempRole) {
						tempInx++;
						if (tempInx === indx) {
							tempInxValue = inx;
						}
					}
				});

				arr.splice(tempInxValue, 1);
				newArr = arr;
			} else {
				newArr =
					_.remove(arr, {
						name: id,
						subRole: category,
						role: tempRole,
					}) && arr;
			}

			this.setState(
				{
					editShootDetails: {
						...this.state.editShootDetails,
						crewNew: newArr,
					},
				},
				() => {
					if (
						id === this.state.emptyCrewName &&
						category === this.state[`${role}emptyCrewCategory`]
					) {
						this.setState({
							[`${role}crewNameError`]: false,
							[`${role}crewCategoryError`]: false,
						});
					}
				},
			);
		} else {
			arr = [...this.state[`${role}crew`]];

			let newArr;
			if (id === null) {
				let tempInx = -1;
				let tempInxValue = null;
				_.forEach(arr, (crw, inx) => {
					if (crw.role === tempRole) {
						tempInx++;
						if (tempInx === indx) {
							tempInxValue = inx;
						}
					}
				});

				arr.splice(tempInxValue, 1);
				newArr = arr;
			} else {
				newArr = _.remove(arr, { name: id, subRole: category, role: tempRole }) && arr;
			}

			this.setState(
				{
					[`${role}crew`]: newArr,
				},
				() => {
					if (
						id === this.state[`${role}emptyCrewName`] &&
						category === this.state[`${role}emptyCrewCategory`]
					) {
						this.setState({
							[`${role}crewNameError`]: false,
							[`${role}crewCategoryError`]: false,
						});
					}
				},
			);
		}
	};

	handleChangeCrewCategory = (newValue, role) => {
		this.setState(
			{
				[`${role}emptyCrewCategoryArr`]: newValue,
				[`${role}emptyCrewCategory`]: newValue.value,
				[`${role}emptyCrewRole`]: role === 'shoot' ? 'photographer' : 'cinematographer',
			},
			() => {
				if (
					this.state[`${role}emptyCrewCategory`] !== null &&
					this.state[`${role}emptyCrewName`] !== null
				) {
					let arr;
					if (this.props.activeShootID !== null) {
						arr = [...this.state.editShootDetails.crewNew];

						if (
							_.size(
								_.filter(this.state.editShootDetails.crewNew, {
									name: this.state[`${role}emptyCrewName`],
									role: role === 'shoot' ? 'photographer' : 'cinematographer',
									subRole: this.state[`${role}emptyCrewCategory`],
								}),
							) == 0
						) {
							let foundIndex = -1;
							let isManager = false;
							foundIndex = _.findIndex(arr, {
								name: this.state[`${role}emptyCrewName`],
								isManager: true,
							});
							if (foundIndex !== -1) {
								isManager = true;
							}
							arr.push({
								name: this.state[`${role}emptyCrewName`],
								role: role === 'shoot' ? 'photographer' : 'cinematographer',
								subRole: this.state[`${role}emptyCrewCategory`],
								isManager,
							});
							this.setState({
								editShootDetails: {
									...this.state.editShootDetails,
									crewNew: arr,
								},
								[`${role}emptyCrewCategoryArr`]: {},
								[`${role}emptyCrewNameArr`]: {},
								[`${role}emptyCrewName`]: null,
								[`${role}emptyCrewCategory`]: null,
								[`${role}crewNameError`]: false,
								[`${role}crewCategoryError`]: false,
							});
						} else {
							this.setState({
								[`${role}crewNameError`]: true,
								[`${role}crewCategoryError`]: true,
							});
						}
					} else {
						arr = [...this.state[`${role}crew`]];
						if (
							_.size(
								_.filter(this.state[`${role}crew`], {
									name: this.state[`${role}emptyCrewName`],
									role: this.state[`${role}emptyCrewRole`],
									subRole: this.state[`${role}emptyCrewCategory`],
								}),
							) == 0
						) {
							let foundIndex = -1;
							let isManager = false;
							foundIndex = _.findIndex(
								[...this.state.shootcrew, ...this.state.videocrew],
								{
									name: this.state[`${role}emptyCrewName`],
									isManager: true,
								},
							);
							if (foundIndex !== -1) {
								isManager = true;
							}
							arr.push({
								name: this.state[`${role}emptyCrewName`],
								role: this.state[`${role}emptyCrewRole`],
								subRole: this.state[`${role}emptyCrewCategory`],
								isManager,
							});
							this.setState({
								[`${role}crew`]: arr,
								[`${role}emptyCrewName`]: null,
								[`${role}emptyCrewCategory`]: null,
								[`${role}emptyCrewCategoryArr`]: {},
								[`${role}emptyCrewNameArr`]: {},
								[`${role}crewNameError`]: false,
								[`${role}crewCategoryError`]: false,
							});
						} else {
							this.setState({
								[`${role}crewNameError`]: true,
								[`${role}crewCategoryError`]: true,
							});
						}
					}
				} else if (
					this.state[`${role}emptyCrewCategory`] !== null &&
					this.state[`${role}emptyCrewName`] === null
				) {
					let arr;
					if (this.props.activeShootID !== null) {
						arr = [...this.state.editShootDetails.crewNew];

						arr.push({
							name: null,
							role: role === 'shoot' ? 'photographer' : 'cinematographer',
							subRole: this.state[`${role}emptyCrewCategory`],
							isManager: false,
						});
						this.setState({
							editShootDetails: {
								...this.state.editShootDetails,
								crewNew: arr,
							},
							[`${role}emptyCrewCategoryArr`]: {},
							[`${role}emptyCrewNameArr`]: {},
							[`${role}emptyCrewName`]: null,
							[`${role}emptyCrewCategory`]: null,
							[`${role}crewNameError`]: false,
							[`${role}crewCategoryError`]: false,
						});
					} else {
						arr = [...this.state[`${role}crew`]];

						arr.push({
							name: null,
							role: this.state[`${role}emptyCrewRole`],
							subRole: this.state[`${role}emptyCrewCategory`],
							isManager: false,
						});
						this.setState({
							[`${role}crew`]: arr,
							[`${role}emptyCrewName`]: null,
							[`${role}emptyCrewCategory`]: null,
							[`${role}emptyCrewCategoryArr`]: {},
							[`${role}emptyCrewNameArr`]: {},
							[`${role}crewNameError`]: false,
							[`${role}crewCategoryError`]: false,
						});
					}
				}
			},
		);
	};

	/* handleCreateName = (e, role) => {
		let crewOptions = [...this.state.tenantUsersListOptions];
		let newCrew = { label: e, value: moment().unix() };
		crewOptions.push(newCrew);

		this.handleChangeCrewName(newCrew, 'create', role);
		this.setState({
			tenantUsersListOptions: crewOptions,
		});
	}; */

	addNote = async (e, id = null) => {
		if (this.props.activeShootID !== null) {
			let response = false;
			let json = {
				projectId:
					_.has(this.props, 'projectId') && this.props.projectId
						? this.props.projectId
						: this.props.params.projectID,
				eventId: this.props.activeShootID,
				workspaceId:
					_.has(this.props, 'workspaceID') && this.props.workspaceID
						? this.props.workspaceID
						: this.props.params.workspaceID,
				noteInput: {
					message: e.target.value,
				},
			};
			response = await this.addNewProjectNote(addShootNote, json, 'shoot');
			if (response !== false) {
				let shootDetails = _.cloneDeep(this.state.shootDetails);
				/* let filteredShoots = this.state.filteredShoots;
				let inx = -1;
				inx = _.findIndex(shootsDetails, { id: id });
				if (inx !== -1) {
					shootsDetails[inx].notes = response;
				}
				_.forEach(filteredShoots, (item, indexKey) => {
					_.forEach(item, (shoot, shootKey) => {
						if (_.size(shoot) > 0) {
							let isfound = false;
							isfound = filteredShoots[indexKey][shootKey].id === id;
							if (isfound) {
								filteredShoots[indexKey][shootKey].notes = response;
							}
						}
					});
				}); */
				shootDetails.notes = response;
				this.setState({
					editShootDetails: {
						...this.state.editShootDetails,
						notes: response,
					},
					//filteredShoots,
					shootDetails,
				});
			}
		} else {
			let arr = this.state.newAddedNote;
			arr.push({ message: e.target.value });
			this.setState({
				newAddedNote: arr,
			});
		}
	};

	deleteNewNote = (e, key) => {
		let arr = [...this.state.newAddedNote];
		arr.splice(key, 1);
		this.setState({
			newAddedNote: arr,
		});
	};

	deleteEditNote = async (e, key, note, id) => {
		if (this.props.activeShootID !== null) {
			let response = false;
			let json = {
				projectId:
					_.has(this.props, 'projectId') && this.props.projectId
						? this.props.projectId
						: this.props.params.projectID,
				eventId: id,
				workspaceId:
					_.has(this.props, 'workspaceID') && this.props.workspaceID
						? this.props.workspaceID
						: this.props.params.workspaceID,
				noteId: note._id,
			};
			response = await this.deleteProjectNote(deleteShootNote, json);
			if (response !== false) {
				response = response.deleteEventNote.notes;
				let shootDetails = _.cloneDeep(this.state.shootDetails);
				let editShootDetails = _.cloneDeep(this.state.editShootDetails);
				/* let arr = this.state.editShootDetails.notes;
				arr.splice(key, 1); */
				editShootDetails.notes = response;
				shootDetails.notes = response;

				/* let filteredShoots = this.state.filteredShoots;
				_.forEach(filteredShoots, (item, indexKey) => {
					_.forEach(item, (shoot, shootKey) => {
						if (_.size(shoot) > 0) {
							let isfound = false;
							isfound = filteredShoots[indexKey][shootKey].id === id;
							if (isfound) {
								filteredShoots[indexKey][shootKey].notes = response;
							}
						}
					});
				}); */
				this.setState({
					editShootDetails,
					//filteredShoots,
					shootDetails,
				});
			}
		} else {
			let arr = this.state.editShootDetails.notes;
			arr.splice(key, 1);
			this.setState({
				editShootDetails: {
					...this.state.editShootDetails,
					notes: arr,
				},
			});
		}
	};

	handleEditNote = (e, key) => {
		let arr = _.cloneDeep(this.state.editShootDetails.notes);
		arr[key] = { ...arr[key], message: e.target.value };
		delete arr[key]['__typename'];
		this.setState({
			editShootDetails: {
				...this.state.editShootDetails,
				notes: arr,
			},
		});
	};

	handleBlurEditNote = async (e, key, note, id, subType) => {
		let response = false;
		let json = {
			eventId: id,
			projectId:
				_.has(this.props, 'projectId') && this.props.projectId
					? this.props.projectId
					: this.props.params.projectID,
			workspaceId:
				_.has(this.props, 'workspaceID') && this.props.workspaceID
					? this.props.workspaceID
					: this.props.params.workspaceID,
			noteId: note._id,
			noteInput: {
				message: note.message,
			},
		};
		response = await this.updateProjectNote(updateShootNote, json, 'shoot');
		if (response !== false) {
			let editShootDetails = _.cloneDeep(this.state.editShootDetails);
			let shootDetails = _.cloneDeep(this.state.shootDetails);
			editShootDetails.notes = response;
			shootDetails.notes = response;

			this.setState({
				editShootDetails,
				shootDetails,
			});
		}
	};

	handleAddNote = (e, key) => {
		let arr = [...this.state.newAddedNote];
		arr[key] = { ...arr[key], message: e.target.value };
		this.setState({
			newAddedNote: arr,
		});
	};

	handleDelete = (e) => {
		let json;
		let projectId = this.state.projectId;
		let deleteEventId = this.props.activeShootID;
		json = {
			deleteEventId,
			projectId,
		};
		this.putShoot(deleteShoot, json, null, null, 'delete');
	};
	handleUnlinkEvent = (e) => {
		let json = {
			projectId: this.state.projectId,
			unMergeEventId: this.props.activeShootID,
		};
		this.unMergeEvent(unMergeEvent, json);
	};
	isDisabled = () => {
		if (this.props.activeShootID === null) {
			if (
				this.state.name == null ||
				this.state.name === '' ||
				this.state.editShootNameError === true ||
				this.state.videocrewNameError === true ||
				this.state.videocrewCategoryError === true ||
				this.state.shootcrewNameError === true ||
				this.state.shootcrewCategoryError === true
			) {
				return true;
			} else {
				return false;
			}
		} else if (this.props.activeShootID !== null) {
			if (
				this.state.editShootDetails.name === null ||
				this.state.editShootDetails.name === '' ||
				this.state.editShootNameError === true ||
				this.state.videocrewNameError === true ||
				this.state.videocrewCategoryError === true ||
				this.state.shootcrewNameError === true ||
				this.state.shootcrewCategoryError === true ||
				(this.state.shootDetails.name === this.state.editShootDetails.name &&
					this.state.editShootDetails.name !== null &&
					this.state.editShootDetails.name !== '' &&
					this.state.editShootNameError === false &&
					this.state.shootDetails.projectId === this.state.editShootDetails.projectId &&
					this.state.shootDetails.city === this.state.editShootDetails.city &&
					this.state.shootDetails.time === this.state.editShootDetails.time &&
					this.state.shootDetails.reportingTime ===
						this.state.editShootDetails.reportingTime &&
					this.state.shootDetails.venue === this.state.editShootDetails.venue &&
					this.state.shootDetails.durationInHrs ===
						this.state.editShootDetails.durationInHrs &&
					this.state.shootDetails.date === this.state.editShootDetails.date &&
					this.state.editShootDetails.linkedTo === null &&
					this.state.shootDetails.outStation === this.state.editShootDetails.outStation &&
					_.isEqual(this.state.shootDetails.crewNew, this.state.editShootDetails.crewNew))
			) {
				return true;
			} else {
				return false;
			}
		}
	};

	handleCloseModal = () => {
		if (this.props.activeShootID === null) {
			this.setState({ showDiscardModal: true });
		} else if (this.props.activeShootID !== null) {
			if (
				this.state.shootDetails.name === this.state.editShootDetails.name &&
				this.state.shootDetails.projectId === this.state.editShootDetails.projectId &&
				this.state.shootDetails.city === this.state.editShootDetails.city &&
				this.state.shootDetails.time === this.state.editShootDetails.time &&
				this.state.shootDetails.venue === this.state.editShootDetails.venue &&
				this.state.shootDetails.durationInHrs ===
					this.state.editShootDetails.durationInHrs &&
				this.state.shootDetails.date === this.state.editShootDetails.date &&
				this.state.editShootDetails.linkedTo === null &&
				_.isEqual(this.state.shootDetails.crew, this.state.editShootDetails.crew)
			) {
				this.props.handleClose();
			} else {
				this.setState({ showDiscardModal: true });
			}
		}
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
				custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				{this.state.isShootLoading === true || this.state.isProjectsLoading === true ? (
					<LoadingBar />
				) : (
					<>
						<div className="project-add-edit-popup edit-shoot-details">
							<div
								className="project-add-edit-popup-header"
								style={{
									alignItems:
										this.props.activeShootID == null ? 'center' : 'flex-start',
									flexDirection:
										this.props.activeShootID == null ? 'row' : 'column',
									height: this.props.activeShootID == null ? '56px' : '70px',
								}}
							>
								{/* <span className="header-title">
									{this.props.activeShootID == null
										? 'New Shoot'
										: this.state.editShootDetails.name +
										  ' · ' +
										  this.props.projectTitle +
										  ' · ' +
										  this.props.workspaceID}
								</span> */}
								{this.props.activeShootID == null ? (
									<span className="header-title">New Shoot</span>
								) : (
									<>
										<div className="projectTitleInCreateShoot">
											{this.props.projectTitle}
										</div>
										<div className="shootTitleInCreateShoot">
											{this.state.editShootDetails.name}
										</div>
									</>
								)}

								{/* {this.props.activeShootID !== null ? (
                                    <span
                                        className="header-more-icn"
                                        onClick={(e) => this.toggleDropDown(e)}
                                    >
                                        <MoreVerticalIcon />
                                    </span>
                                ) : null} */}
								{this.state.showDropDown === true ? (
									<div className="delete-action-dropdown">
										<div
											className="delete-action-item"
											ref={this.dropdownref}
											onClick={(e) =>
												this.setState({
													showDeleteConfirmationModal: true,
												})
											}
										>
											<span className="delete-icn">
												<DeleteIcon />
											</span>
											<span className="delete-text">Delete Shoot</span>
										</div>
									</div>
								) : null}
							</div>
							{/* <div className="project-add-edit-popup-subheader shoot-subheader">
								<a
									href="#details"
									className={
										this.state.currentTab === 'details'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'details',
										})
									}
								>
									DETAILS
								</a>
								<a
									href="#shoot-crew"
									className={
										this.state.currentTab === 'shoot-crew'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'shoot-crew',
										})
									}
								>
									SHOOT CREW
								</a>
								<a
									href="#video-crew"
									className={
										this.state.currentTab === 'video-crew'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'video-crew',
										})
									}
								>
									VIDEO CREW
								</a>
								{this.props.activeShootID !== null &&
								this.props.data &&
								this.props.data.childEvents !== null &&
								_.size(this.props.data.childEvents) > 0 ? (
									<a
										href="#parent-shoot-to"
										className={
											this.state.currentTab === 'eventslinking'
												? 'sub-header-title active'
												: 'sub-header-title'
										}
										onClick={() =>
											this.setState({
												currentTab: 'eventslinking',
											})
										}
									>
										PARENT SHOOT TO
									</a>
								) : (
									''
								)}
								{this.props.activeShootID !== null ? (
									<a
										href="#additional-services"
										className={
											this.state.currentTab === 'additional-services'
												? 'sub-header-title active'
												: 'sub-header-title'
										}
										onClick={() =>
											this.setState({
												currentTab: 'additional-services',
											})
										}
									>
										ADDITIONAL SERVICES
									</a>
								) : null}
								<a
									href="#comments"
									className={
										this.state.currentTab === 'comments'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'comments',
										})
									}
								>
									COMMENTS
								</a>
							</div> */}
							<div className="project-add-edit-popup-body">
								{(_.has(this.props, 'displayOnly') &&
									(this.props.displayOnly === null ||
										this.props.displayOnly === 'details')) ||
								!_.has(this.props, 'displayOnly') ? (
									<div
										className="project-add-edit-popup-body-item"
										id={'details'}
									>
										<div className="popup-body-title">SHOOT DETAILS</div>
										{_.has(this.props, 'isTenantCreate') &&
										this.props.isTenantCreate ? (
											<div className="floating-select-container">
												<label>Project</label>
												<Select
													className="cost-select-container zIndex3 w-100p"
													classNamePrefix="cost-select"
													options={this.state.projectNameOptions}
													onChange={(e) =>
														this.setState({
															projectId: e.value,
														})
													}
													defaultValue={
														_.size(this.state.projectNameOptions) > 0
															? this.state.projectNameOptions[0]
															: null
													}
													isSearchable={false}
													onMenuScrollToBottom={(e) =>
														this.fetchMoreOptions()
													}
												/>
											</div>
										) : (
											<InputHeader
												type="text"
												name="project"
												value={this.props.projectTitle}
												readOnly={true}
												onChange={(e) => {}}
												isInputError={false}
												label="Project"
											/>
										)}
										{/* {this.props.activeShootID !== null ? (
                                            <>
                                                <div
                                                    className="event-sections"
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent:
                                                            'space-between',
                                                        gap: '20px',
                                                    }}
                                                >
                                                    <InputHeader
                                                        type="text"
                                                        name="event"
                                                        value={
                                                            this.props
                                                                .activeShootID ==
                                                            null
                                                                ? this.state
                                                                      .name
                                                                : this.state
                                                                      .editShootDetails
                                                                      .name
                                                        }
                                                        isInputError={
                                                            this.state
                                                                .editShootNameError
                                                        }
                                                        errorMessage={
                                                            this.state
                                                                .editShootNameError &&
                                                            this.state
                                                                .editShootNameErrorMessage
                                                                ? this.state
                                                                      .editShootNameErrorMessage
                                                                : this.state
                                                                      .editShootNameError
                                                                ? 'required'
                                                                : ''
                                                        }
                                                        required={true}
                                                        label="Event"
                                                        onChange={(e) =>
                                                            this.handleEventChange(
                                                                e,
                                                                'name'
                                                            )
                                                        }
                                                    />
                                                    <InputHeader
                                                        type="text"
                                                        name="parent_event"
                                                        value={
                                                            this.props
                                                                .activeShootID ==
                                                            null
                                                                ? this.state
                                                                      .name
                                                                : this.state
                                                                      .editShootDetails
                                                                      .name
                                                        }
                                                        isInputError={
                                                            this.state
                                                                .editShootNameError
                                                        }
                                                        errorMessage={
                                                            this.state
                                                                .editShootNameError &&
                                                            this.state
                                                                .editShootNameErrorMessage
                                                                ? this.state
                                                                      .editShootNameErrorMessage
                                                                : this.state
                                                                      .editShootNameError
                                                                ? 'required'
                                                                : ''
                                                        }
                                                        // required={true}
                                                        // placeholder="hehe"
                                                        label="Parent Event"
                                                        onChange={(e) =>
                                                            this.handleEventChange(
                                                                e,
                                                                'name'
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <> */}
										<InputHeader
											type="text"
											name="event"
											value={
												this.props.activeShootID == null
													? this.state.name
													: this.state.editShootDetails.name
											}
											isInputError={this.state.editShootNameError}
											errorMessage={
												this.state.editShootNameError &&
												this.state.editShootNameErrorMessage
													? this.state.editShootNameErrorMessage
													: this.state.editShootNameError
													? 'required'
													: ''
											}
											required={true}
											label="Event"
											onChange={(e) => this.handleEventChange(e, 'name')}
										/>
										{/* </>
                                        )} */}
										{/* <div
                                            className="event-sections"
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                gap: '20px',
                                            }}
                                        >
                                            <InputHeader
                                                type="text"
                                                name="event"
                                                value={
                                                    this.props.activeShootID ==
                                                    null
                                                        ? this.state.name
                                                        : this.state
                                                              .editShootDetails
                                                              .name
                                                }
                                                isInputError={
                                                    this.state
                                                        .editShootNameError
                                                }
                                                errorMessage={
                                                    this.state
                                                        .editShootNameError &&
                                                    this.state
                                                        .editShootNameErrorMessage
                                                        ? this.state
                                                              .editShootNameErrorMessage
                                                        : this.state
                                                              .editShootNameError
                                                        ? 'required'
                                                        : ''
                                                }
                                                required={true}
                                                label="Event"
                                                onChange={(e) =>
                                                    this.handleEventChange(
                                                        e,
                                                        'name'
                                                    )
                                                }
                                            />
                                            <InputHeader
                                                type="text"
                                                name="parent_event"
                                                value={
                                                    this.props.activeShootID ==
                                                    null
                                                        ? this.state.name
                                                        : this.state
                                                              .editShootDetails
                                                              .name
                                                }
                                                isInputError={
                                                    this.state
                                                        .editShootNameError
                                                }
                                                errorMessage={
                                                    this.state
                                                        .editShootNameError &&
                                                    this.state
                                                        .editShootNameErrorMessage
                                                        ? this.state
                                                              .editShootNameErrorMessage
                                                        : this.state
                                                              .editShootNameError
                                                        ? 'required'
                                                        : ''
                                                }
                                                // required={true}
                                                // placeholder="hehe"
                                                label="Parent Event"
                                                onChange={(e) =>
                                                    this.handleEventChange(
                                                        e,
                                                        'name'
                                                    )
                                                }
                                            />
                                        </div> */}
										{/* <InputHeader
                                            type="text"
                                            name="event"
                                            value={
                                                this.props.activeShootID == null
                                                    ? this.state.name
                                                    : this.state
                                                          .editShootDetails.name
                                            }
                                            isInputError={
                                                this.state.editShootNameError
                                            }
                                            errorMessage={
                                                this.state.editShootNameError &&
                                                this.state
                                                    .editShootNameErrorMessage
                                                    ? this.state
                                                          .editShootNameErrorMessage
                                                    : this.state
                                                          .editShootNameError
                                                    ? 'required'
                                                    : ''
                                            }
                                            required={true}
                                            label="Event"
                                            onChange={(e) =>
                                                this.handleEventChange(
                                                    e,
                                                    'name'
                                                )
                                            }
                                        /> */}
										{/* {this.props.activeShootID !== null ? (
                                            <div className="floating-select-container">
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        position: 'relative',
                                                    }}
                                                >
                                                    <label>
                                                        Linked to Event
                                                    </label>
                                                    {this.state.editShootDetails
                                                        .parentEvent_id !==
                                                    null ? (
                                                        <span
                                                            className="event-unlink"
                                                            onClick={(e) =>
                                                                this.handleUnlinkEvent(
                                                                    e
                                                                )
                                                            }
                                                        >
                                                            Unlink
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                {this.props.data &&
                                                this.props.data.childEvents !==
                                                    null &&
                                                _.size(
                                                    this.props.data.childEvents
                                                ) > 0 ? (
                                                    <InputHeader
                                                        value={
                                                            'None (This is a parent shoot)'
                                                        }
                                                        readOnly={true}
                                                    />
                                                ) : this.state.editShootDetails
                                                      .parentEventName ||
                                                  this.state.editShootDetails
                                                      .parentEvent_id ===
                                                      null ? (
                                                    <Select
                                                        //this.state.editShootDetails.parentEventName
                                                        className="cost-select-container zIndex2 w-100p"
                                                        classNamePrefix="cost-select"
                                                        options={
                                                            this.state
                                                                .eventNameOptions
                                                        }
                                                        onChange={(e) =>
                                                            this.handleEventChange(
                                                                e,
                                                                'linkedTo'
                                                            )
                                                        }
                                                        placeholder=""
                                                        defaultValue={
                                                            this.state
                                                                .editShootDetails
                                                                .parentEvent_id ==
                                                            null
                                                                ? null
                                                                : _.find(
                                                                      this.state
                                                                          .eventNameOptions,
                                                                      {
                                                                          value: this
                                                                              .state
                                                                              .editShootDetails
                                                                              .parentEvent_id,
                                                                      }
                                                                  )
                                                        }
                                                        isSearchable={false}
                                                        isDisabled={true}
                                                    />
                                                ) : null}
                                            </div>
                                        ) : null} */}
										<DatePicker
											selected={
												this.props.activeShootID == null
													? this.state.date == null
														? null
														: moment(
																this.state.date.toString(),
																'YYYYMMDD',
														  ).toDate()
													: this.state.editShootDetails.date &&
													  this.state.editShootDetails.date !== null
													? moment(
															this.state.editShootDetails.date.toString(),
															'YYYYMMDD',
													  ).toDate()
													: null
											}
											onChange={(e) => this.handleEventChange(e, 'date')}
											dateFormat="dd/MM/yyyy"
											//placeholderText="dd / mm / yyyy"
											openToDate={new Date()}
											customInput={<CustomDateInput customLabel="Date" />}
											wrapperClassName={`w-100p ${
												this.state.editShootDetails.parentEvent_id !== null
													? 'disabledInput'
													: ''
											}`}
											disabled={
												this.props.activeShootID !== null &&
												this.state.editShootDetails.parentEvent_id !== null
											}
										/>
										<div
											className="timing-sections"
											style={{
												display: 'flex',
												gap: '20px',
											}}
										>
											<DatePicker
												selected={
													this.props.activeShootID == null
														? this.state.reportingTime !== null
															? this.state.reportingTime === ''
																? ''
																: moment(
																		this.state.reportingTime,
																		'hh:mm aa',
																  ).toDate()
															: null
														: this.state.editShootDetails
																.reportingTime &&
														  this.state.editShootDetails
																.reportingTime !== null
														? moment(
																this.state.editShootDetails
																	.reportingTime,
																'hh:mm aa',
														  ).toDate()
														: null
												}
												onChange={(e) =>
													this.handleEventChange(e, 'reportingTime')
												}
												//placeholderText="hh : mm am/pm"
												showTimeSelect
												showTimeSelectOnly
												dateFormat="hh:mm aa"
												customInput={
													<CustomDateInput customLabel="Reporting Time" />
												}
												wrapperClassName={`w-100p ${
													this.state.editShootDetails.parentEvent_id !==
													null
														? 'disabledInput'
														: ''
												}`}
												disabled={
													this.props.activeShootID !== null &&
													this.state.editShootDetails.parentEvent_id !==
														null
												}
											/>

											<div className="floating-select-container">
												<label>Time Slot</label>
												<Select
													className="cost-select-container w-100p"
													classNamePrefix="cost-select"
													options={this.state.timeTypeOptions}
													onChange={(e) =>
														this.handleEventChange(e, 'time-new-format')
													}
													defaultValue={
														this.props.activeShootID == null
															? this.state.timeTypeOptions[0]
															: this.state.editShootDetails.time
															? _.filter(this.state.timeTypeOptions, {
																	value: this.state
																		.editShootDetails.time,
															  })[0]
															: this.state.timeTypeOptions[0]
													}
													isSearchable={false}
													isDisabled={
														this.props.activeShootID !== null &&
														this.state.editShootDetails
															.parentEvent_id !== null
													}
												/>
											</div>
										</div>
										<div
											className="city-section"
											style={{
												display: 'flex',
												gap: '20px',
											}}
										>
											<InputHeader
												type="text"
												name="event"
												value={
													this.props.activeShootID == null
														? this.state.city
														: this.state.editShootDetails.city
												}
												isInputError={false}
												label="City"
												onChange={(e) => this.handleEventChange(e, 'city')}
												readOnly={
													this.props.activeShootID !== null &&
													this.state.editShootDetails.parentEvent_id !==
														null
												}
											/>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: '8px',
												}}
											>
												<input
													// idnput"
													checked={
														this.props.activeShootID == null
															? this.state.outStation
																? true
																: false
															: this.state.editShootDetails.outStation
															? true
															: false
													}
													type="checkbox"
													name="outStation"
													value={
														this.props.activeShootID == null
															? this.state.outStation
															: this.state.editShootDetails.outStation
													}
													// isInputError={false}
													// label="Outstation"
													onChange={(e) =>
														this.handleEventChange(e, 'outStation')
													}
													readOnly={
														this.props.activeShootID !== null &&
														this.state.editShootDetails.outStation !==
															null
													}
												/>
												<p style={{ color: '#E4E5E6' }}>Outstation</p>
											</div>
										</div>

										{/* <DatePicker
                                            selected={
                                                this.props.activeShootID == null
                                                    ? this.state.date == null
                                                        ? null
                                                        : moment(
                                                              this.state.date.toString(),
                                                              'YYYYMMDD'
                                                          ).toDate()
                                                    : this.state
                                                          .editShootDetails
                                                          .date &&
                                                      this.state
                                                          .editShootDetails
                                                          .date !== null
                                                    ? moment(
                                                          this.state.editShootDetails.date.toString(),
                                                          'YYYYMMDD'
                                                      ).toDate()
                                                    : null
                                            }
                                            onChange={(e) =>
                                                this.handleEventChange(
                                                    e,
                                                    'date'
                                                )
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            //placeholderText="dd / mm / yyyy"
                                            openToDate={new Date()}
                                            customInput={
                                                <CustomDateInput customLabel="Date" />
                                            }
                                            wrapperClassName={`w-100p ${
                                                this.state.editShootDetails
                                                    .parentEvent_id !== null
                                                    ? 'disabledInput'
                                                    : ''
                                            }`}
                                            disabled={
                                                this.props.activeShootID !==
                                                    null &&
                                                this.state.editShootDetails
                                                    .parentEvent_id !== null
                                            }
                                        /> */}
										{/* <div className="timing-sections" style={{
                                                    display: "flex", gap:"20px"

                                                }}>
                                            <DatePicker
                                                selected={
                                                    this.props.activeShootID ==
                                                    null
                                                        ? this.state
                                                              .reportingTime !==
                                                          null
                                                            ? this.state
                                                                  .reportingTime ===
                                                              ''
                                                                ? ''
                                                                : moment(
                                                                      this.state
                                                                          .reportingTime,
                                                                      'hh:mm aa'
                                                                  ).toDate()
                                                            : null
                                                        : this.state
                                                              .editShootDetails
                                                              .reportingTime &&
                                                          this.state
                                                              .editShootDetails
                                                              .reportingTime !==
                                                              null
                                                        ? moment(
                                                              this.state
                                                                  .editShootDetails
                                                                  .reportingTime,
                                                              'hh:mm aa'
                                                          ).toDate()
                                                        : null
                                                }
                                                onChange={(e) =>
                                                    this.handleEventChange(
                                                        e,
                                                        'reportingTime'
                                                    )
                                                }
                                                //placeholderText="hh : mm am/pm"
                                                showTimeSelect
                                                showTimeSelectOnly
                                                dateFormat="hh:mm aa"
                                                customInput={
                                                    <CustomDateInput customLabel="Reporting Time" />
                                                }
                                                wrapperClassName={`w-100p ${
                                                    this.state.editShootDetails
                                                        .parentEvent_id !== null
                                                        ? 'disabledInput'
                                                        : ''
                                                }`}
                                                disabled={
                                                    this.props.activeShootID !==
                                                        null &&
                                                    this.state.editShootDetails
                                                        .parentEvent_id !== null
                                                }
                                            />

                                            <div className="floating-select-container">
                                                <label>Time Slot</label>
                                                <Select
                                                    className="cost-select-container w-100p"
                                                    classNamePrefix="cost-select"
                                                    options={
                                                        this.state
                                                            .timeTypeOptions
                                                    }
                                                    onChange={(e) =>
                                                        this.handleEventChange(
                                                            e,
                                                            'time-new-format'
                                                        )
                                                    }
                                                    defaultValue={
                                                        this.props
                                                            .activeShootID ==
                                                        null
                                                            ? this.state
                                                                  .timeTypeOptions[0]
                                                            : this.state
                                                                  .editShootDetails
                                                                  .time
                                                            ? _.filter(
                                                                  this.state
                                                                      .timeTypeOptions,
                                                                  {
                                                                      value: this
                                                                          .state
                                                                          .editShootDetails
                                                                          .time,
                                                                  }
                                                              )[0]
                                                            : this.state
                                                                  .timeTypeOptions[0]
                                                    }
                                                    isSearchable={false}
                                                    isDisabled={
                                                        this.props
                                                            .activeShootID !==
                                                            null &&
                                                        this.state
                                                            .editShootDetails
                                                            .parentEvent_id !==
                                                            null
                                                    }
                                                />
                                            </div>
                                        </div> */}

										<InputHeader
											type="text"
											name="duration"
											value={
												this.props.activeShootID == null
													? this.state.duration
													: this.state.editShootDetails.durationInHrs
											}
											isInputError={false}
											label="Duration (hrs)"
											onChange={(e) => this.handleEventChange(e, 'duration')}
										/>
										<InputHeader
											textarea={true}
											type="text"
											name="venue"
											value={
												this.props.activeShootID == null
													? this.state.venue
													: this.state.editShootDetails.venue
											}
											isInputError={false}
											label="Venue address"
											onChange={(e) => this.handleEventChange(e, 'venue')}
											readOnly={
												this.state.editShootDetails.parentEvent_id !==
													null && this.props.activeShootID !== null
											}
										/>
									</div>
								) : (
									''
								)}

								{(_.has(this.props, 'displayOnly') &&
									this.props.displayOnly === 'crew') ||
								(_.has(this.props, 'displayOnly') &&
									this.props.displayOnly === null) ||
								!_.has(this.props, 'displayOnly') ? (
									<>
									<div
										className="project-add-edit-popup-body-item gap-24px"
										id={'shoot-crew'}
									>
										<div className="popup-body-title">PHOTO CREW</div>
										<div className="crew-row-container">
											<span className="popup-body-title">NAME</span>
											<span className="popup-body-title">ROLE</span>
											<span
												className="popup-body-title"
												style={{ flex: 0.5 }}
											>
												MANAGER
											</span>
										</div>
										{_.map(
											this.props.activeShootID !== null
												? _.filter(this.state.editShootDetails.crewNew, {
														role: 'photographer',
												  })
												: this.state.shootcrew,
											(crew, key, collection) => {
												if (
													_.has(crew, 'isCustomUser') &&
													crew.isCustomUser === true
												) {
													return null;
												}
												return (
													<div
														className="crew-row-container"
														style={{
															zIndex: _.size(collection) - key + 104,
														}}
														key={
															key +
															crew.subRole +
															crew.name +
															crew.role
														}
													>
														<Select
															className="crew-select-container popup-body-title pos-absolute"
															classNamePrefix="crew-select"
															onChange={(e) =>
																this.handleEditCrewName(
																	e,
																	crew.name,
																	key,
																	'shoot',
																	crew.subRole,
																)
															}
															isSearchable={true}
															options={
																this.state.tenantUsersListOptions
															}
															value={_.filter(
																this.state.tenantUsersListOptions,
																{
																	value: crew.name,
																},
															)}
															isDisabled={
																this.state.editShootDetails
																	.parentEvent_id !== null &&
																this.props.activeShootID !== null
															}
														/>
														<Select
															className="crew-select-container popup-body-title pos-absolute w-80"
															classNamePrefix="crew-select"
															onChange={(e) =>
																this.handleEditCrewCategory(
																	e,
																	crew.name,
																	key,
																	'shoot',
																	crew.subRole,
																)
															}
															options={categoryOptions}
															value={_.filter(categoryOptions, {
																value: crew.subRole,
															})}
															isDisabled={
																this.state.editShootDetails
																	.parentEvent_id !== null &&
																this.props.activeShootID !== null
															}
														/>
														<div
															className="input-minus-wrapper"
															style={{
																flex: 0.5,
																justifyContent: 'center',
															}}
														>
															{moment(crew.name).isValid() ||
															crew.name === null ? (
																''
															) : (
																<label
																	className={
																		'download-label manager-label'
																	}
																	key={
																		key +
																		crew.subRole +
																		crew.name +
																		crew.role
																	}
																	onClick={(e) =>
																		this.toggleEditCrewManager(
																			e,
																			crew.name,
																			key,
																			'shoot',
																			crew.subRole,
																			!crew.isManager,
																		)
																	}
																>
																	<div className={'round'}>
																		<input
																			className={`radio-input ${key}`}
																			type={'checkbox'}
																			id={'checkbox4'}
																			checked={crew.isManager}
																		/>
																		<label
																			for={'checkbox4'}
																		></label>
																	</div>
																</label>
															)}
															{this.state.editShootDetails
																.parentEvent_id !== null &&
															this.props.activeShootID !== null ? (
																''
															) : (
																<b
																	onClick={(e) =>
																		this.handleDeleteCrew(
																			e,
																			crew.name,
																			crew.subRole,
																			'shoot',
																			key,
																		)
																	}
																>
																	<MinusIcon />
																</b>
															)}
														</div>
													</div>
												);
											},
										)}
										{this.state.editShootDetails.parentEvent_id == null ||
										this.props.activeShootID == null ? (
											<>
												<div class={'crew-row-container'}>
													<Select
														className={`crew-select-container popup-body-title pos-absolute ${
															this.state.shootcrewNameError
																? 'input-error'
																: ''
														}`}
														classNamePrefix="crew-select"
														onChange={(e) =>
															this.handleChangeCrewName(
																e,
																null,
																'shoot',
															)
														}
														/* onCreateOption={(e) =>
															this.handleCreateName(e, 'shoot')
														} */
														styles={{
															container: (base) => ({
																...base,
																zIndex: 101,
															}),
														}}
														options={this.state.tenantUsersListOptions}
														placeholder={''}
														value={
															_.isEmpty(
																this.state.shootemptyCrewNameArr,
															)
																? null
																: this.state.shootemptyCrewNameArr
														}
													/>
													<Select
														className={`crew-select-container popup-body-title pos-absolute ${
															this.state.shootcrewCategoryError
																? 'input-error'
																: ''
														}`}
														id={this.id}
														classNamePrefix="crew-select"
														onChange={(e) =>
															this.handleChangeCrewCategory(
																e,
																'shoot',
															)
														}
														options={categoryOptions}
														placeholder={''}
														value={
															_.isEmpty(
																this.state
																	.shootemptyCrewCategoryArr,
															)
																? null
																: this.state
																		.shootemptyCrewCategoryArr
														}
													/>
													<span
														className="popup-body-title"
														style={{ flex: 0.5 }}
													></span>
												</div>
												<div className="crew-row-container">
													<span
														className="popup-body-title"
														style={{ flex: 1 }}
													></span>
													<div className="crew-error-text-new">
														{this.state.shootcrewCategoryError
															? _.isEmpty(
																	this.state
																		.shootemptyCrewCategory,
															  )
																? 'Please choose shoot crew role'
																: 'Duplicate crew role not allowed'
															: ''}
													</div>
													<span
														className="popup-body-title"
														style={{ flex: 0.5 }}
													></span>
												</div>
											</>
										) : (
											''
										)}
									</div>
									</>
								) : (
									''
								)}

								{(_.has(this.props, 'displayOnly') &&
									this.props.displayOnly === 'crew') ||
								(_.has(this.props, 'displayOnly') &&
									this.props.displayOnly === null) ||
								!_.has(this.props, 'displayOnly') ? (
									<div
										className="project-add-edit-popup-body-item gap-24px"
										id={'video-crew'}
									>
										<div className="popup-body-title">VIDEO CREW</div>
										<div className="crew-row-container">
											<span className="popup-body-title">NAME</span>
											<span className="popup-body-title">ROLE</span>
											<span
												className="popup-body-title"
												style={{ flex: 0.5 }}
											>
												MANAGER
											</span>
										</div>
										{_.map(
											this.props.activeShootID !== null
												? _.filter(this.state.editShootDetails.crewNew, {
														role: 'cinematographer',
												  })
												: this.state.videocrew,
											(crew, key, collection) => {
												if (
													_.has(crew, 'isCustomUser') &&
													crew.isCustomUser === true
												) {
													return null;
												}
												return (
													<div className="crew-row-container">
														<Select
															className="crew-select-container popup-body-title pos-absolute"
															classNamePrefix="crew-select"
															onChange={(e) =>
																this.handleEditCrewName(
																	e,
																	crew.name,
																	key,
																	'video',
																	crew.subRole,
																)
															}
															styles={{
																container: (base) => ({
																	...base,
																	zIndex:
																		_.size(collection) -
																		key +
																		3,
																}),
															}}
															isSearchable={true}
															options={
																this.state.tenantUsersListOptions
															}
															value={_.filter(
																this.state.tenantUsersListOptions,
																{
																	value: crew.name,
																},
															)}
															isDisabled={
																this.state.editShootDetails
																	.parentEvent_id !== null &&
																this.props.activeShootID !== null
															}
														/>
														<Select
															className="crew-select-container popup-body-title pos-absolute w-80"
															classNamePrefix="crew-select"
															onChange={(e) =>
																this.handleEditCrewCategory(
																	e,
																	crew.name,
																	key,
																	'video',
																	crew.subRole,
																)
															}
															options={categoryOptions}
															value={_.filter(categoryOptions, {
																value: crew.subRole,
															})}
															isDisabled={
																this.state.editShootDetails
																	.parentEvent_id !== null &&
																this.props.activeShootID !== null
															}
														/>
														<div
															className="input-minus-wrapper"
															style={{
																flex: 0.5,
																justifyContent: 'center',
															}}
														>
															{moment(crew.name).isValid() ||
															crew.name === null ? (
																''
															) : (
																<label
																	className={
																		'download-label manager-label'
																	}
																	onClick={(e) =>
																		this.toggleEditCrewManager(
																			e,
																			crew.name,
																			key,
																			'video',
																			crew.subRole,
																			!crew.isManager,
																		)
																	}
																>
																	<div className={'round'}>
																		<input
																			className={
																				'radio-input'
																			}
																			type={'checkbox'}
																			id={'checkbox4'}
																			checked={crew.isManager}
																		/>
																		<label
																			for={'checkbox4'}
																		></label>
																	</div>
																</label>
															)}

															{this.state.editShootDetails
																.parentEvent_id !== null &&
															this.props.activeShootID !== null ? (
																''
															) : (
																<b
																	onClick={(e) =>
																		this.handleDeleteCrew(
																			e,
																			crew.name,
																			crew.subRole,
																			'video',
																			key,
																		)
																	}
																>
																	<MinusIcon />
																</b>
															)}
														</div>
													</div>
												);
											},
										)}
										{this.state.editShootDetails.parentEvent_id == null ||
										this.props.activeShootID == null ? (
											<>
												<div class={'crew-row-container'}>
													<Select
														className={`crew-select-container zIndex2 popup-body-title pos-absolute ${
															this.state.videocrewNameError
																? 'input-error'
																: ''
														}`}
														classNamePrefix="crew-select"
														onChange={(e) =>
															this.handleChangeCrewName(
																e,
																null,
																'video',
															)
														}
														/* onCreateOption={(e) =>
															this.handleCreateName(e, 'video')
														} */
														options={this.state.tenantUsersListOptions}
														placeholder={''}
														value={
															_.isEmpty(
																this.state.videoemptyCrewNameArr,
															)
																? null
																: this.state.videoemptyCrewNameArr
														}
													/>
													<Select
														className={`crew-select-container popup-body-title pos-absolute ${
															this.state.videocrewCategoryError
																? 'input-error'
																: ''
														}`}
														id={this.id}
														classNamePrefix="crew-select"
														onChange={(e) =>
															this.handleChangeCrewCategory(
																e,
																'video',
															)
														}
														options={categoryOptions}
														placeholder={''}
														value={
															_.isEmpty(
																this.state
																	.videoemptyCrewCategoryArr,
															)
																? null
																: this.state
																		.videoemptyCrewCategoryArr
														}
													/>
													<span
														className="popup-body-title"
														style={{ flex: 0.5 }}
													></span>
												</div>
												<div className="crew-row-container">
													<span
														className="popup-body-title"
														style={{ flex: 1 }}
													></span>
													<div className="crew-error-text-new">
														{this.state.videocrewCategoryError
															? _.isEmpty(
																	this.state
																		.videoemptyCrewCategoryArr,
															  )
																? 'Please choose video crew role'
																: 'Duplicate crew role not allowed'
															: ''}
													</div>
													<span
														className="popup-body-title"
														style={{ flex: 0.5 }}
													></span>
												</div>
											</>
										) : (
											''
										)}
									</div>
								) : (
									''
								)}

								{this.props.activeShootID && this.state.isCrewPlannerUser &&
									(this.state.editShootDetails.crewNew || []).some(c => !c.name && c.role) && (
									<div className="project-add-edit-popup-body-item gap-24px">
										<CrewSuggestions
											eventId={this.props.activeShootID}
											vendorId={this.props.params.vendorID}
											unassignedRoles={
												(this.state.editShootDetails.crewNew || [])
													.filter(c => !c.name && c.role)
													.map(c => ({ role: c.role, subRole: c.subRole }))
											}
											assignedUserIds={
												(this.state.editShootDetails.crewNew || [])
													.map(c => c.name)
													.filter(Boolean)
											}
										/>
									</div>
								)}

								{this.props.activeShootID !== null &&
								this.props.data &&
								this.props.data.childEvents !== null &&
								_.size(this.props.data.childEvents) > 0 ? (
									<div
										className="project-add-edit-popup-body-item gap-24px"
										id={'parent-shoot-to'}
									>
										<div className="popup-body-title">PARENT SHOOT TO</div>

										<div className="child-events">
											{_.map(this.props.data.childEvents, (child, key) => {
												return (
													<>
														<a className="child-event">{child.name}</a>
													</>
												);
											})}
										</div>
									</div>
								) : (
									''
								)}
								{this.props.activeShootID !== null ? null : (
									<div
										className="project-add-edit-popup-body-item gap-24px"
										id={'additional-services'}
									>
										<div className="popup-body-title">
											ADDITIONAL SERVICES (
											{_.size(this.state.additionalServices)})
										</div>
										<div className="additional-services-container">
											{_.map(this.state.additionalServices, (item, index) => {
												return (
													<div className="add-svr-item">
														<span className="add-svr-text">
															{
																_.find(this.state.addServOptions, {
																	value: item.type,
																})?.label
															}
														</span>
														<span
															className="delete-icon"
															onClick={(e) =>
																this.handleDeleteAdditionalService(
																	null,
																	null,
																	index,
																)
															}
														>
															<DeleteIcon />
														</span>
													</div>
												);
											})}
											<div
												className="add-svcr-dropdown-btn"
												onClick={(e) => this.toggleAddSvcrDropDown(e)}
												ref={this.addSvcrRef}
											>
												<span className="add-svcr-drop-icn">
													<PlusIcon />
												</span>
												{this.state.showAddSvcrDropdown ? (
													<div
														className="add-svcr-drop-container"
														ref={this.addSvcrDropdownRef}
													>
														{_.map(
															this.state.addServOptions,
															(item, index) => {
																if (
																	_.findIndex(
																		this.state
																			.additionalServices,
																		{
																			type: item.value,
																		},
																	) !== -1
																) {
																	return null;
																} else {
																	return (
																		<a
																			className="add-svcr-drop-item"
																			onClick={(e) =>
																				this.handleAddAdditionalService(
																					item.value,
																					item.label,
																				)
																			}
																		>
																			{item.label}
																		</a>
																	);
																}
															},
														)}
													</div>
												) : (
													''
												)}
											</div>
										</div>
									</div>
								)}
								{this.props.activeShootID !== null &&
								((_.has(this.props, 'displayOnly') &&
									(this.props.displayOnly === 'additional-service' ||
										this.props.displayOnly === 'details')) ||
									(_.has(this.props, 'displayOnly') &&
										this.props.displayOnly === null) ||
									!_.has(this.props, 'displayOnly')) ? (
									<div
										className="project-add-edit-popup-body-item gap-24px"
										id={'additional-services'}
									>
										<div className="popup-body-title">
											ADDITIONAL SERVICES (
											{_.size(this.state.shootDetails.additionalServices)})
										</div>
										<div className="additional-services-container">
											{_.map(
												this.state.shootDetails.additionalServices,
												(item, index) => {
													return (
														<div className="add-svr-item">
															<span className="add-svr-text">
																{
																	_.find(
																		this.state.addServOptions,
																		{
																			value: item.type,
																		},
																	)?.label
																}
															</span>
															<span
																className="delete-icon"
																onClick={(e) =>
																	this.handleDeleteAdditionalService(
																		item.type,
																		_.find(
																			this.state
																				.addServOptions,
																			{
																				value: item.type,
																			},
																		)?.label,
																		item._id,
																	)
																}
															>
																<DeleteIcon />
															</span>
														</div>
													);
												},
											)}
											<div
												className="add-svcr-dropdown-btn"
												onClick={(e) => this.toggleAddSvcrDropDown(e)}
												ref={this.addSvcrRef}
											>
												<span className="add-svcr-drop-icn">
													<PlusIcon />
												</span>
												{this.state.showAddSvcrDropdown ? (
													<div
														className="add-svcr-drop-container"
														ref={this.addSvcrDropdownRef}
													>
														{_.map(
															this.state.addServOptions,
															(item, index) => {
																if (
																	_.findIndex(
																		this.state.shootDetails
																			.additionalServices,
																		{
																			type: item.value,
																		},
																	) !== -1
																) {
																	return null;
																} else {
																	return (
																		<a
																			className="add-svcr-drop-item"
																			onClick={(e) =>
																				this.handleAddAdditionalService(
																					item.value,
																					item.label,
																				)
																			}
																		>
																			{item.label}
																		</a>
																	);
																}
															},
														)}
													</div>
												) : (
													''
												)}
											</div>
										</div>
									</div>
								) : (
									''
								)}
								{(_.has(this.props, 'displayOnly') &&
									(this.props.displayOnly === null ||
										this.props.displayOnly === 'details')) ||
								!_.has(this.props, 'displayOnly') ? (
									<div
										className="project-add-edit-popup-body-item"
										id={'comments'}
									>
										<div className="popup-body-title">COMMENTS</div>
										{_.size(
											this.props.activeShootID !== null
												? this.state.editShootDetails.notes
												: this.state.notes,
										) === 0 ? (
											<div className="comment-no-comments-text">
												No Comments
											</div>
										) : (
											_.map(
												this.props.activeShootID !== null
													? this.state.editShootDetails.notes
													: this.state.notes,
												(note, key) => {
													return (
														<div className="notes-item-container">
															<InputHeader
																textarea={true}
																type="text"
																isInputError={false}
																label={
																	(note.updatedBy !== null &&
																	_.filter(
																		this.state.tenantUsersList,
																		{
																			key: note.updatedBy,
																		},
																	).length > 0
																		? `by ${
																				_.filter(
																					this.state
																						.tenantUsersList,
																					{
																						key: note.updatedBy,
																					},
																				)[0]?.name
																		  },`
																		: note.createdBy !== null &&
																		  _.filter(
																				this.state
																					.tenantUsersList,
																				{
																					key: note.createdBy,
																				},
																		  ).length > 0
																		? `by ${
																				_.filter(
																					this.state
																						.tenantUsersList,
																					{
																						key: note.createdBy,
																					},
																				)[0]?.name
																		  },`
																		: '') +
																	(note.updatedAt !== null
																		? ` ${moment
																				.unix(
																					note.updatedAt,
																				)
																				.format(
																					'D MMM YYYY h:mm a',
																				)}`
																		: note.createdAt !== null
																		? ` ${moment
																				.unix(
																					note.createdAt,
																				)
																				.format(
																					'D MMM YYYY h:mm a',
																				)}`
																		: '')
																}
																onChange={(e) =>
																	this.handleEditNote(e, key)
																}
																onBlur={(e) => {
																	if (
																		this.props.activeShootID !==
																		null
																	) {
																		this.handleBlurEditNote(
																			e,
																			key,
																			note,
																			this.state
																				.editShootDetails
																				.id,
																		);
																	}
																}}
																value={note.message}
															/>
															<div
																className="right-delete-container"
																onClick={(e) =>
																	this.deleteEditNote(
																		e,
																		key,
																		note,
																		this.state.editShootDetails
																			.id,
																	)
																}
															>
																<DeleteIcon />
															</div>
														</div>
													);
												},
											)
										)}
										{_.map(this.state.newAddedNote, (note, key) => {
											return (
												<div className="notes-item-container">
													<InputHeader
														textarea={true}
														type="text"
														isInputError={false}
														label={
															(_.filter(this.state.tenantUsersList, {
																key: this.state.userId,
															}).length > 0
																? `by ${
																		_.filter(
																			this.state
																				.tenantUsersList,
																			{
																				id: this.state
																					.userId,
																			},
																		)[0]?.name
																  },`
																: '') +
															` ${moment(new Date()).format(
																'D MMM YYYY h:mm a',
															)}`
														}
														onChange={(e) => this.handleAddNote(e, key)}
														value={note.message}
													/>
													<div
														className="right-delete-container"
														onClick={(e) => this.deleteNewNote(e, key)}
													>
														<DeleteIcon />
													</div>
												</div>
											);
										})}
										<div className="notes-item-container">
											<InputHeader
												textarea={true}
												type="text"
												isInputError={false}
												label="New note"
												onChange={(e) => {
													this.setState({ storedNote: e.target.value });
												}}
												value={this.state.storedNote}
												onBlur={(e) => {
													if (e.target.value !== '') {
														this.addNote(e, this.props.activeShootID);
														this.setState({ storedNote: '' });
													}
												}}
											/>
										</div>
									</div>
								) : null}
							</div>
							{_.has(this.props, 'displayOnly') &&
							this.props.displayOnly === 'additional-service' ? null : (
								<div className="bottom-popup-action-container">
									<span
										className="cancel-btn"
										onClick={() => this.handleCloseModal()}
									>
										Cancel
									</span>
									{this.state.disabledBtn ? (
										''
									) : (
										<span
											className={
												this.isDisabled()
													? 'add-edit-btn disabled'
													: 'add-edit-btn'
											}
											onClick={(e) => {
												if (!this.isDisabled()) {
													if (this.props.activeShootID == null) {
														this.handleAddShoot(e);
													} else {
														this.handleSaveShoot(e);
													}
												}
											}}
										>
											<span className="plus-icn">
												<PlusIcon />
											</span>
											<span>
												{this.props.activeShootID === null
													? 'Create Shoot'
													: 'Save Shoot'}
											</span>
										</span>
									)}
								</div>
							)}
						</div>
						<Modal
							handleClose={() =>
								this.setState({
									showDeleteConfirmationModal: false,
								})
							}
							show={this.state.showDeleteConfirmationModal}
							modalType={'center'}
						>
							<div className="center-confirm-delete-new">
								<div className="delete-modal-header">DELETE SHOOT</div>
								<div className="middle-delete-container">
									<div className="middle-text">Are you sure?</div>
									<div className="middle-desc">
										Once deleted, you cannot undo this action
									</div>
								</div>
								<div className="bottom-delete-btns">
									<span
										className="cancel-btn"
										onClick={(e) =>
											this.setState({
												showDeleteConfirmationModal: false,
											})
										}
									>
										No, cancel
									</span>
									<span
										className="delete-btn"
										onClick={(e) => this.handleDelete(e)}
									>
										Yes, delete
									</span>
								</div>
							</div>
						</Modal>
						<Modal
							handleClose={() => this.setState({ showDiscardModal: false })}
							show={this.state.showDiscardModal}
							modalType={'center'}
						>
							<div className="center-confirm-delete-new">
								<div className="delete-modal-header">DISCARD CHANGES</div>
								<div className="middle-delete-container">
									<div className="middle-text">Are you sure?</div>
									<div className="middle-desc">
										If you discard this information, you cannot undo this
									</div>
								</div>
								<div className="bottom-delete-btns">
									<span
										className="cancel-btn"
										onClick={(e) =>
											this.setState({
												showDiscardModal: false,
											})
										}
									>
										No, Cancel
									</span>
									<span
										className="delete-btn"
										onClick={(e) => {
											this.props.handleClose();
											this.setState({
												showDiscardModal: false,
											});
										}}
									>
										Yes, Discard
									</span>
								</div>
							</div>
						</Modal>
					</>
				)}
			</Modal>
		);
	}
}

export default withRouter(CreateShoot);
